import { useCanManageCoaching } from '@/hooks/auth/useCanManageCoaching'
import { useRole } from '@/hooks/useRole'
import { ClerkUserRole } from '@/types/auth'

export type CoachingPortalEntry = {
  /** Whether to offer the *Coaching Portal* entry in the user menu at all. */
  readonly isAvailable: boolean
  /** Where that entry lands. */
  readonly path: string
}

/**
 * The user menu's Coaching Portal entry (ENG-3568). Not an authorization check.
 * A coach lands on their portal home. A coaching manager super admin lands on Staffing, because their `/admin` is the administration dashboard.
 */
export function useCoachingPortalEntry(): CoachingPortalEntry {
  const { userRole, isLoaded } = useRole()
  const { canManageCoaching } = useCanManageCoaching()

  if (isLoaded && userRole === ClerkUserRole.SUPER_ADMIN) {
    return { isAvailable: canManageCoaching, path: '/admin/coaching/staffing' }
  }
  return { isAvailable: isLoaded && userRole === ClerkUserRole.COACH, path: '/admin' }
}
